import { render, staticRenderFns } from "./UploadImageButton.vue?vue&type=template&id=1e2a7969"
import script from "./UploadImageButton.vue?vue&type=script&lang=js"
export * from "./UploadImageButton.vue?vue&type=script&lang=js"
import style0 from "./UploadImageButton.vue?vue&type=style&index=0&id=1e2a7969&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports